import React, { useState } from "react";
import BookingForm from "../components/BookingForm";
import "../components/BookingFormData.css";
import ReviewsSlider from "../components/ReviewsSlider";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../css/BookingPage.css";

export default function BookingPage() {

  const bgUrl = "/images/tiger.jpg";

  const [selectedPackage, setSelectedPackage] = useState(null);

  const handleSelectPackage = (pkg) => {
    setSelectedPackage(pkg);

    const form = document.querySelector(".bf-card");
    if (form) {
      form.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Ranthambore Tour Packages with Safari | Plan Your Wildlife Trip
        </title>

        <meta
          name="description"
          content="Explore Ranthambore tour packages including hotel stay, safari experience, and complete travel assistance."
        />
      </Helmet>

      <Header />

      {/* HERO */}
      <div
        className="hero-bg"
        style={{ "--hero-image": `url(${bgUrl})` }}
      >
        <div className="hero-overlay">

          <div className="hero-heading">
            <h1>Ranthambore Tour Packages with Safari Experience</h1>

            <p>
              Plan your Ranthambore wildlife trip with curated tour packages including stay, safari assistance, and local guidance.
            </p>

            <h2 className="hero-subheading">
              Complete travel planning with safari experience, accommodation, and expert local support.
            </h2>

            <div className="trust-badges">
              <span>✔ Curated Tour Packages</span>
              <span>✔ Travel Planning Support</span>
              <span>✔ Local Guidance</span>
              <span>✔ Seamless Experience</span>
            </div>
          </div>

          <div className="hero-content">
            <BookingForm selectedPackage={selectedPackage} />
          </div>

        </div>
      </div>

      {/* DISCLAIMER */}
      <div style={{
        background: "#f5f5f5",
        padding: "12px",
        textAlign: "center",
        fontSize: "14px"
      }}>
        <p>
          We are a private travel service provider offering Ranthambore tour packages.
          We are not affiliated with the Forest Department or Government of Rajasthan.
        </p>
      </div>

      {/* PACKAGES */}
      <div className="packages-section">

        <h2 className="section-title">Ranthambore Tour Packages</h2>

        <div className="packages-grid">

          {/* CARD 1 */}
          <div
            className={`package-card ${selectedPackage === "2N" ? "highlight" : ""}`}
            onClick={() => handleSelectPackage("2N/3D")}
          >
            <h3>2N/3D Ranthambore Package</h3>

            <ul>
              <li>✔ Hotel Stay</li>
              <li>✔ Safari Assistance</li>
              <li>✔ Local Travel Support</li>
            </ul>

            <p className="price">₹4,999 per person</p>

            <button className="package-btn">Plan This Trip</button>
          </div>

          {/* CARD 2 */}
          <div
            className={`package-card ${selectedPackage === "3N" ? "highlight" : ""}`}
            onClick={() => handleSelectPackage("3N/4D")}
          >
            {selectedPackage === "3N" && (
              <div className="badge">Best Seller</div>
            )}

            <h3>3N/4D Wildlife Experience</h3>

            <ul>
              <li>✔ Premium Stay</li>
              <li>✔ Multiple Safari Assistance</li>
              <li>✔ Guided Trip Planning</li>
            </ul>

            <p className="price">₹10,999 per person</p>

            <button className="package-btn">Explore Package</button>
          </div>

          {/* CARD 3 */}
          <div
            className={`package-card ${selectedPackage === "custom" ? "highlight" : ""}`}
            onClick={() => handleSelectPackage("CUSTOM")}
          >
            <h3>Custom Ranthambore Tour</h3>

            <ul>
              <li>✔ Personalized Itinerary</li>
              <li>✔ Hotel + Safari Assistance</li>
              <li>✔ Transport Support</li>
            </ul>

            <p className="price">Custom Pricing</p>

            <button className="package-btn">Get Custom Plan</button>
          </div>

        </div>

      </div>

      {/* HOW IT WORKS */}
      <div className="why-section">

        <h2>How It Works</h2>

        <div className="why-grid">

          <div className="why-card">
            <h3>Share Travel Details</h3>
            <p>Tell us your preferred dates and number of travelers.</p>
          </div>

          <div className="why-card">
            <h3>Get Package Options</h3>
            <p>We suggest suitable Ranthambore tour packages.</p>
          </div>

          <div className="why-card">
            <h3>Safari Assistance</h3>
            <p>We assist in arranging safari as part of your travel plan.</p>
          </div>

          <div className="why-card">
            <h3>Enjoy Your Trip</h3>
            <p>Experience wildlife with complete support and guidance.</p>
          </div>

        </div>

      </div>

      {/* WHY US */}
      <div className="why-section">

        <h2>Why Choose Us</h2>

        <div className="why-grid">

          <div className="why-card">
            <h3>Travel Planning Experts</h3>
            <p>
              We help travelers plan complete Ranthambore trips including safari arrangements and stay.
            </p>
          </div>

          <div className="why-card">
            <h3>Customized Packages</h3>
            <p>
              Flexible tour packages tailored to your travel preferences and dates.
            </p>
          </div>

          <div className="why-card">
            <h3>Transparent Pricing</h3>
            <p>
              Clear pricing including travel assistance and safari arrangement support.
            </p>
          </div>

          <div className="why-card">
            <h3>Local Guidance</h3>
            <p>
              Helpful information about safari zones, timings, and travel tips.
            </p>
          </div>

        </div>

      </div>

      {/* TESTIMONIALS */}
      <div className="testimonial-section">
        <h2>What Our Customers Say</h2>
        <ReviewsSlider />
      </div>

      {/* LINKS */}
      <div className="safari-links">

        <h2>Explore Ranthambore Travel Guides</h2>

        <Link to="/jeep-safari-ranthambore">
          Jeep Safari Guide
        </Link>

        <Link to="/canter-safari-ranthambore">
          Canter Safari Guide
        </Link>

      </div>

    </>
  );
}